import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  DateTimeInput,
  required,
  BooleanInput,
} from 'react-admin';
import {
  NotificationType,
  NotificationPriority,
} from '../../generated/data-contracts';
import { Box, Typography } from '@mui/material';

export const NotificationsEdit: React.FC = () => (
  <Edit title='Editar Notificación'>
    <SimpleForm>
      <Box display='flex' flexDirection='column' gap={2}>
        <Box>
          <Typography variant='h6' gutterBottom>
            Información Básica
          </Typography>
          <TextInput
            source='title'
            label='Título'
            validate={[required()]}
            fullWidth
          />

          <TextInput
            source='content'
            label='Contenido'
            multiline
            rows={4}
            validate={[required()]}
            fullWidth
          />
        </Box>

        <Box>
          <Typography variant='h6' gutterBottom>
            Configuración
          </Typography>
          <SelectInput
            source='type'
            label='Tipo'
            choices={[
              { id: NotificationType.Info, name: 'Información' },
              { id: NotificationType.Warning, name: 'Advertencia' },
              { id: NotificationType.Alert, name: 'Alerta' },
              { id: NotificationType.Success, name: 'Éxito' },
            ]}
            validate={[required()]}
          />

          <SelectInput
            source='priority'
            label='Prioridad'
            choices={[
              { id: NotificationPriority.Low, name: 'Baja' },
              { id: NotificationPriority.Medium, name: 'Media' },
              { id: NotificationPriority.High, name: 'Alta' },
              { id: NotificationPriority.Critical, name: 'Crítica' },
            ]}
          />

          <DateTimeInput
            source='expiresAt'
            label='Fecha de Expiración'
            helperText='Opcional: Fecha y hora en que expira la notificación'
          />

          <BooleanInput
            source='isActive'
            label='Notificación Activa'
            helperText='Determina si la notificación está activa o desactivada'
          />
        </Box>
      </Box>
    </SimpleForm>
  </Edit>
);
